(function() {
	'use strict';

	angular.module('acarsMessages').config(config);

	function config($stateProvider) {
		$stateProvider.state('acarsMessages', {
			url : '/acars-messages',
			views : {
				'acarsMessagesView' : {
					templateUrl : 'acars-messages/views/acars-messages.tpl.html',
					controller : 'AcarsMessagesCtrl',
					controllerAs : 'acarsMessages'
				}
			}
		});
	}
}());
